/**
 * change state of exam filter
 * @param val
 */
export const changeExamFilterVal = (val) => dispatch => {
    dispatch( {
        type: 'EXAM_FILTER_CHANGE',
        payload: val
    });
};